module.exports = __webpack_public_path__ + "static/bg-designing-1277b35eabba83478af0ce57a390d66a.svg";